import { useSyncExternalStore } from 'react';

const useMedia = (mediaQuery: string) => {
  return useSyncExternalStore(
    (callback) => {
      const matchMedia = window.matchMedia(mediaQuery);

      matchMedia.addEventListener('change', callback);
      return () => {
        matchMedia.removeEventListener('change', callback);
      };
    },
    () => {
      return window.matchMedia(mediaQuery).matches;
    },
    () => {
      return null;
    }
  );
};

// NOTE: tailwind値と同期できたら嬉しい
// isDesktop/isTablet/isMobile はビューポート幅基準（レスポンシブレイアウト用）。
// isTouchDevice はデバイス入力特性基準（タッチ操作・物理キーボード非搭載の判定用）。
export const useResponsive = () => {
  const sp = 450;
  const tab = 768;
  const isDesktop = useMedia(`(min-width: ${tab}px)`);
  const isTablet = useMedia(`(min-width: ${sp}px) and (max-width: ${tab - 1}px)`);
  const hasFinePointer = useMedia('(pointer: fine) and (hover: hover)');
  const isMobile = !isDesktop && !isTablet;
  if (isDesktop === null || isTablet === null || hasFinePointer === null) {
    return { isDesktop: false, isTablet: false, isMobile: false, isTouchDevice: false, isReady: false };
  }

  return { isDesktop, isTablet, isMobile, isTouchDevice: !hasFinePointer, isReady: true };
};
